import React from "react";
import { Tooltip } from "antd";
import "./ORMWidget.css";
import { CaretUpFilled, CaretDownFilled } from "@ant-design/icons";
import { simpleKFormatterOnly } from "../../../redux/constants";

const TatSummary = ({ single, defualtvalue, tat, preview }) => {
  const secondsToDhms = (seconds) => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? " D, " : " D, ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? " h, " : " h, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " m, " : " m, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " s" : " s") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  };
  return (
    <div className="p-15">
      {/* <div className="row">
        <div className="col-12 col-md-5">
          <div className="border border-color p-15 mb-15">
            <div className="text-gray font-size12">
              {single?.TotalTickets?.text}
            </div>
            <div className="portlet__title fontSize-16 font-weight500">
              {simpleKFormatterOnly(single?.TotalTickets?.value)}
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  single?.TotalTickets?.percent_change === 0 && "d-none"
                } ${
                  single?.TotalTickets?.percent_change > 0
                    ? "positive"
                    : "negative"
                }`}
              >
                {single?.TotalTickets?.percent_change > 0 ? (
                  <i className="fa fa-caret-up mr-1" />
                ) : (
                  <i className="fa fa-caret-down mr-1" />
                )}
                {single?.TotalTickets?.percent_change}%
              </span>
            </div>
          </div>
          <div className="border border-color p-15 mb-15">
            <div className="text-gray font-size12">
              {single?.OnHoldTickets?.text}
            </div>
            <div className="portlet__title fontSize-16 font-weight500">
              {simpleKFormatterOnly(single?.OnHoldTickets?.value)}
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  single?.OnHoldTickets?.percent_change === 0 && "d-none"
                } ${
                  single?.OnHoldTickets?.percent_change > 0
                    ? "positive"
                    : "negative"
                }`}
              >
                {single?.OnHoldTickets?.percent_change > 0 ? (
                  <i className="fa fa-caret-up mr-1" />
                ) : (
                  <i className="fa fa-caret-down mr-1" />
                )}
                {single?.OnHoldTickets?.percent_change}%
              </span>
            </div>
          </div>
          <div className="border border-color p-15">
            <div className="text-gray font-size12">
              {single?.TotalTickets?.text}
            </div>
            <div className="portlet__title fontSize-16 font-weight500">
              {simpleKFormatterOnly(single?.Pending?.value)}
              <span
                className={`font-size12 font-weight400 ml-1 ${
                  single?.Pending?.percent_change === 0 && "d-none"
                } ${
                  single?.Pending?.percent_change > 0 ? "positive" : "negative"
                }`}
              >
                {single?.Pending?.percent_change > 0 ? (
                  <i className="fa fa-caret-up mr-1" />
                ) : (
                  <i className="fa fa-caret-down mr-1" />
                )}
                {single?.Pending?.percent_change}%
              </span>
            </div>
          </div>
          <div className="d-flex" style={{ width: "34rem" }}>
            <div className="border border-color p-15 w-100">
              <div className="text-gray font-size12">{single?.Agent?.text}</div>
              <div className="portlet__title fontSize-16 font-weight500">
                {simpleKFormatterOnly(single?.Agent?.value)}
                <span
                  className={`font-size12 font-weight400 ml-1 ${
                    single?.Agent?.percent_change === 0 && "d-none"
                  } ${
                    single?.Agent?.percent_change > 0 ? "positive" : "negative"
                  }`}
                >
                  {single?.Agent?.percent_change > 0 ? (
                    <i className="fa fa-caret-up mr-1" />
                  ) : (
                    <i className="fa fa-caret-down mr-1" />
                  )}
                  {single?.Agent?.percent_change}%
                </span>
              </div>
            </div>

            <div className="border border-color p-15 w-100">
              <div className="text-gray font-size12">
                {single?.CSD?.text}{" "}
                <Tooltip
                  placement="bottom"
                  title="Brand pending tickets will be available only when brand workflow is enabled for your group and all the brands have the same configuration."
                >
                  <i className="fa fa-question-circle" />
                </Tooltip>
              </div>
              <div className="portlet__title fontSize-16 font-weight500">
                {simpleKFormatterOnly(single?.CSD?.value)}
                <span
                  className={`font-size12 font-weight400 ml-1 ${
                    single?.CSD?.percent_change === 0 && "d-none"
                  } ${
                    single?.CSD?.percent_change > 0 ? "positive" : "negative"
                  }`}
                >
                  {single?.CSD?.percent_change > 0 ? (
                    <i className="fa fa-caret-up mr-1" />
                  ) : (
                    <i className="fa fa-caret-down mr-1" />
                  )}
                  {single?.CSD?.percent_change}%
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-7">
          <div className="Main__DIYwidgets">
            <div className="DIY__widgets text-center">
              <div className="portlet1 box-shadow-none border-0 p-0 m-0 ">
                <div className="counter-conatiner p-0">
                  <div className="text-gray font-size12">
                    {single?.TotalClosedTickets?.text}
                  </div>
                  <div className="portlet__title fontSize-16 font-weight500">
                    {simpleKFormatterOnly(single?.TotalClosedTickets?.value)}
                    <span
                      className={`font-size12 font-weight400 ml-1 ${
                        single?.TotalClosedTickets?.percent_change === 0 &&
                        "d-none"
                      } ${
                        single?.TotalClosedTickets?.percent_change > 0
                          ? "positive"
                          : "negative"
                      }`}
                    >
                      {single?.TotalClosedTickets?.percent_change > 0 ? (
                        <i className="fa fa-caret-up mr-1" />
                      ) : (
                        <i className="fa fa-caret-down mr-1" />
                      )}
                      {single?.TotalClosedTickets?.percent_change}%
                    </span>
                  </div>
                </div>
              </div>
              <div className="main__arrow-box">
                <div className="line_center-arrow">
                  <div className="arrow_box"></div>
                </div>
                <div className="line"></div>
                <div className="line_left-arrow">
                  <div className="arrow_box"></div>
                </div>
                <div className="line_right-arrow">
                  <div className="arrow_box"></div>
                </div>
              </div>

              <div className="arrow__bottom_box d-flex justify-content-between">
                <div className="portlet box-shadow-none border-0 m-0">
                  <div className="counter-conatiner p-0">
                    <div className="text-gray font-size12">
                      {single?.DirectlyClosed?.text}
                    </div>
                    <div className="portlet__title fontSize-16 font-weight500">
                      {simpleKFormatterOnly(single?.DirectlyClosed?.value)}
                      <span
                        className={`font-size12 font-weight400 ml-1 ${
                          single?.DirectlyClosed?.percent_change === 0 &&
                          "d-none"
                        } ${
                          single?.DirectlyClosed?.percent_change > 0
                            ? "positive"
                            : "negative"
                        }`}
                      >
                        {single?.DirectlyClosed?.percent_change > 0 ? (
                          <i className="fa fa-caret-up mr-1" />
                        ) : (
                          <i className="fa fa-caret-down mr-1" />
                        )}
                        {single?.DirectlyClosed?.percent_change}%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="portlet box-shadow-none border-0 m-0">
                  <div className="counter-conatiner p-0">
                    <div className="text-gray font-size12">
                      {single?.RespondedandClosed?.text}
                    </div>
                    <div className="portlet__title fontSize-16 font-weight500">
                      {simpleKFormatterOnly(single?.RespondedandClosed?.value)}
                      <span
                        className={`font-size12 font-weight400 ml-1 ${
                          single?.RespondedandClosed?.percent_change === 0 &&
                          "d-none"
                        } ${
                          single?.RespondedandClosed?.percent_change > 0
                            ? "positive"
                            : "negative"
                        }`}
                      >
                        {single?.RespondedandClosed?.percent_change > 0 ? (
                          <i className="fa fa-caret-up mr-1" />
                        ) : (
                          <i className="fa fa-caret-down mr-1" />
                        )}
                        {single?.RespondedandClosed?.percent_change}%
                      </span>
                    </div>
                  </div>
                </div>
                <div className="portlet box-shadow-none border-0 m-0">
                  <div className="counter-conatiner p-0">
                    <div className="text-gray font-size12">
                      {single?.EscalatedandClosed?.text}
                    </div>
                    <div className="portlet__title fontSize-16 font-weight500">
                      {simpleKFormatterOnly(single?.EscalatedandClosed?.value)}
                      <span
                        className={`font-size12 font-weight400 ml-1 ${
                          single?.EscalatedandClosed?.percent_change === 0 &&
                          "d-none"
                        } ${
                          single?.EscalatedandClosed?.percent_change > 0
                            ? "positive"
                            : "negative"
                        }`}
                      >
                        {single?.EscalatedandClosed?.percent_change > 0 ? (
                          <i className="fa fa-caret-up mr-1" />
                        ) : (
                          <i className="fa fa-caret-down mr-1" />
                        )}
                        {single?.EscalatedandClosed?.percent_change}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row m-0">
            <div className="col-6 col-md-6 mb-3 pl-0">
              <div className="portlet m-0 border border-color">
                <div className="counter-conatiner text-left p-0">
                  <div className="text-gray font-size12">
                    {single?.AvgTATforClosedTickets?.text}
                  </div>
                  <div className="portlet__title fontSize-16 font-weight500">
                    <span
                      className={
                        single?.AvgTATforClosedTickets?.value > tat
                          ? "error"
                          : ""
                      }
                    >
                      {secondsToDhms(single?.AvgTATforClosedTickets?.value)
                        ? secondsToDhms(single?.AvgTATforClosedTickets?.value)
                        : 0}
                    </span>
                    <span
                      className={`font-size12 font-weight400 ml-1 ${
                        single?.AvgTATforClosedTickets?.percent_change === 0 &&
                        "d-none"
                      } ${
                        single?.AvgTATforClosedTickets?.percent_change > 0
                          ? "positive"
                          : "negative"
                      }`}
                    >
                      {single?.AvgTATforClosedTickets?.percent_change > 0 ? (
                        <i className="fa fa-caret-up mr-1" />
                      ) : (
                        <i className="fa fa-caret-down mr-1" />
                      )}
                      {single?.AvgTATforClosedTickets?.percent_change}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-6 mb-3 px-0">
              <div className="portlet m-0 border border-color">
                <div className="counter-conatiner p-0">
                  <div className="text-gray font-size12">
                    {single?.AvgTATforDirectlyClosedTickets?.text}
                  </div>
                  <div className="portlet__title fontSize-16 font-weight500">
                    <span
                      className={
                        single?.AvgTATforDirectlyClosedTickets?.value > tat
                          ? "error"
                          : ""
                      }
                    >
                      {secondsToDhms(
                        single?.AvgTATforDirectlyClosedTickets?.value
                      )
                        ? secondsToDhms(
                            single?.AvgTATforDirectlyClosedTickets?.value
                          )
                        : 0}
                    </span>
                    <span
                      className={`font-size12 font-weight400 ml-1 ${
                        single?.AvgTATforDirectlyClosedTickets
                          ?.percent_change === 0 && "d-none"
                      } ${
                        single?.AvgTATforDirectlyClosedTickets?.percent_change >
                        0
                          ? "positive"
                          : "negative"
                      }`}
                    >
                      {single?.AvgTATforDirectlyClosedTickets?.percent_change >
                      0 ? (
                        <i className="fa fa-caret-up mr-1" />
                      ) : (
                        <i className="fa fa-caret-down mr-1" />
                      )}
                      {single?.AvgTATforDirectlyClosedTickets?.percent_change}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-6 pl-0">
              <div className="portlet m-0 border border-color">
                <div className="counter-conatiner p-0">
                  <div className="text-gray font-size12">
                    {single?.AvgTATforRespondedClosedTickets?.text}
                  </div>
                  <div className="portlet__title fontSize-16 font-weight500">
                    <span
                      className={
                        single?.AvgTATforRespondedClosedTickets?.value > tat
                          ? "error"
                          : ""
                      }
                    >
                      {secondsToDhms(
                        single?.AvgTATforRespondedClosedTickets?.value
                      )
                        ? secondsToDhms(
                            single?.AvgTATforRespondedClosedTickets?.value
                          )
                        : 0}
                    </span>
                    <span
                      className={`font-size12 font-weight400 ml-1 ${
                        single?.AvgTATforRespondedClosedTickets
                          ?.percent_change === 0 && "d-none"
                      } ${
                        single?.AvgTATforRespondedClosedTickets
                          ?.percent_change > 0
                          ? "positive"
                          : "negative"
                      }`}
                    >
                      {single?.AvgTATforRespondedClosedTickets?.percent_change >
                      0 ? (
                        <i className="fa fa-caret-up mr-1" />
                      ) : (
                        <i className="fa fa-caret-down mr-1" />
                      )}
                      {single?.AvgTATforRespondedClosedTickets?.percent_change}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-6 px-0">
              <div className="portlet m-0 border border-color">
                <div className="counter-conatiner p-0">
                  <div className="text-gray font-size12">
                    {single?.AvgTATForEscalatedClosedTickets?.text}
                  </div>
                  <div className="portlet__title fontSize-16 font-weight500">
                    <span
                      className={
                        single?.AvgTATForEscalatedClosedTickets?.value > tat
                          ? "error"
                          : ""
                      }
                    >
                      {secondsToDhms(
                        single?.AvgTATForEscalatedClosedTickets?.value
                      )
                        ? secondsToDhms(
                            single?.AvgTATForEscalatedClosedTickets?.value
                          )
                        : 0}
                    </span>
                    <span
                      className={`font-size12 font-weight400 ml-1 ${
                        single?.AvgTATForEscalatedClosedTickets
                          ?.percent_change === 0 && "d-none"
                      } ${
                        single?.AvgTATForEscalatedClosedTickets
                          ?.percent_change > 0
                          ? "positive"
                          : "negative"
                      }`}
                    >
                      {single?.AvgTATForEscalatedClosedTickets?.percent_change >
                      0 ? (
                        <i className="fa fa-caret-up mr-1" />
                      ) : (
                        <i className="fa fa-caret-down mr-1" />
                      )}
                      {single?.AvgTATForEscalatedClosedTickets?.percent_change}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-6 pl-0 pr-0 d-none">
              <div className="mainbox border-left-0 m-0"></div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="row mb-15 ">
        <div className="col-12 col-lg-3 col-md-3 ">
          <div
            className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 h-100 d-flex align-items-center`}
            style={{
              boxShadow: "0 0 0.6rem #c3cbd780",
              borderRadius: "0.4rem",
            }}
          >
            <div>
              <div className="text_regular font-weight500 mb-1 line-height-normal">
                <Tooltip
                  title={single?.TotalTickets?.text}
                  placement="topLeft"
                  className="text-ellipsis d-block"
                >
                  {single?.TotalTickets?.text}
                </Tooltip>
              </div>
              <div className="d-flex align-items-baseline">
                <Tooltip
                  placement="bottom"
                  title={single?.TotalTickets?.value?.toLocaleString()}
                >
                  <span className="wm-chart-card-value mr-1">
                    {simpleKFormatterOnly(single?.TotalTickets?.value)}
                  </span>
                </Tooltip>
                {single?.TotalTickets?.percent_change ? (
                  <span
                    className={`text_regular ${
                      single?.TotalTickets?.percent_change === 0
                        ? "d-flex"
                        : "d-flex"
                    } align-items-baseline ${
                      String(single?.TotalTickets?.text).toLowerCase() ===
                      String("Negative").toLowerCase()
                        ? single?.TotalTickets?.percent_change > 0
                          ? "negative"
                          : single?.TotalTickets?.percent_change < 0
                          ? "positive"
                          : "text-gray"
                        : single?.TotalTickets?.percent_change > 0
                        ? "positive"
                        : single?.TotalTickets?.percent_change < 0
                        ? "negative"
                        : "text-gray"
                    } font-size12 font-weight600`}
                  >
                    {single?.TotalTickets?.percent_change > 0 ? (
                      <>
                        <CaretUpFilled className="font-size18" />
                        {" " +
                          Number(
                            single?.TotalTickets?.percent_change
                          )?.toLocaleString() +
                          "%"}
                      </>
                    ) : single?.TotalTickets?.percent_change < 0 ? (
                      <>
                        <CaretDownFilled className="font-size18" />
                        {" " +
                          Number(
                            single?.TotalTickets?.percent_change
                          )?.toLocaleString() +
                          "%"}
                      </>
                    ) : (
                      "NA"
                    )}{" "}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-3 col-md-3">
          <div
            className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 h-100 d-flex align-items-center`}
            style={{
              boxShadow: "0 0 0.6rem #c3cbd780",
              borderRadius: "0.4rem",
            }}
          >
            <div>
              <div className="text_regular font-weight500 mb-1 line-height-normal">
                <Tooltip
                  title={single?.OnHoldTickets?.text}
                  placement="topLeft"
                  className="text-ellipsis d-block"
                >
                  {single?.OnHoldTickets?.text}
                </Tooltip>
              </div>
              <div className="d-flex align-items-baseline">
                <Tooltip title={single?.OnHoldTickets?.value?.toLocaleString()}>
                  <span className="wm-chart-card-value mr-1">
                    {simpleKFormatterOnly(single?.OnHoldTickets?.value)}
                  </span>
                </Tooltip>

                {single?.OnHoldTickets?.percent_change ? (
                  <span
                    className={`text_regular ${
                      single?.OnHoldTickets?.percent_change === 0
                        ? "d-flex"
                        : "d-flex"
                    } align-items-baseline ${
                      String(single?.OnHoldTickets?.text).toLowerCase() ===
                      String("Negative").toLowerCase()
                        ? single?.OnHoldTickets?.percent_change > 0
                          ? "negative"
                          : single?.OnHoldTickets?.percent_change < 0
                          ? "positive"
                          : "text-gray"
                        : single?.OnHoldTickets?.percent_change > 0
                        ? "positive"
                        : single?.OnHoldTickets?.percent_change < 0
                        ? "negative"
                        : "text-gray"
                    } font-size12 font-weight600`}
                  >
                    {single?.OnHoldTickets?.percent_change > 0 ? (
                      <>
                        <CaretUpFilled className="font-size18" />
                        {" " +
                          Number(
                            single?.OnHoldTickets?.percent_change
                          )?.toLocaleString() +
                          "%"}
                      </>
                    ) : single?.OnHoldTickets?.percent_change < 0 ? (
                      <>
                        <CaretDownFilled className="font-size18" />
                        {" " +
                          Number(
                            single?.OnHoldTickets?.percent_change
                          )?.toLocaleString() +
                          "%"}
                      </>
                    ) : (
                      "NA"
                    )}{" "}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-md-6">
          <div
            className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 h-100 bg__gray border d-flex align-items-center justify-content-between `}
            style={{
              boxShadow: "0 0 0.6rem #c3cbd780",
              borderRadius: "0.4rem",
            }}
          >
            <div>
              <div className="text_regular font-weight500 mb-1 line-height-normal">
                <Tooltip
                  title={single?.PendingTickets?.text}
                  placement="topLeft"
                  className="text-ellipsis d-block"
                >
                  {single?.PendingTickets?.text}
                </Tooltip>
              </div>
              <div className="d-flex align-items-baseline">
                <Tooltip
                  title={single?.PendingTickets?.value?.toLocaleString()}
                >
                  <span className="wm-chart-card-value mr-1">
                    {simpleKFormatterOnly(single?.PendingTickets?.value)}
                  </span>
                </Tooltip>

                {single?.PendingTickets?.percent_change ? (
                  <span
                    className={`text_regular ${
                      single?.PendingTickets?.percent_change === 0
                        ? "d-flex"
                        : "d-flex"
                    } align-items-baseline ${
                      String(single?.PendingTickets?.text).toLowerCase() ===
                      String("Negative").toLowerCase()
                        ? single?.PendingTickets?.percent_change > 0
                          ? "negative"
                          : single?.PendingTickets?.percent_change < 0
                          ? "positive"
                          : "text-gray"
                        : single?.PendingTickets?.percent_change > 0
                        ? "positive"
                        : single?.PendingTickets?.percent_change < 0
                        ? "negative"
                        : "text-gray"
                    } font-size12 font-weight600`}
                  >
                    {single?.PendingTickets?.percent_change > 0 ? (
                      <>
                        <CaretUpFilled className="font-size18" />
                        {" " +
                          Number(
                            single?.PendingTickets?.percent_change
                          )?.toLocaleString() +
                          "%"}
                      </>
                    ) : single?.PendingTickets?.percent_change < 0 ? (
                      <>
                        <CaretDownFilled className="font-size18" />
                        {" " +
                          Number(
                            single?.PendingTickets?.percent_change
                          )?.toLocaleString() +
                          "%"}
                      </>
                    ) : (
                      "NA"
                    )}{" "}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className=" d-flex align-items-center ml-15 p-15 box-shadow border-radius-4 bg__white">
              <div
                className={`border-right border-color mr-15 pr-15 ${
                  preview ? " " : "wm-chart-cards-item"
                }`}
              >
                <div className="text_regular font-weight500 mb-1 line-height-normal">
                  <Tooltip
                    title={single?.Agent?.text}
                    placement="topLeft"
                    className="text-ellipsis d-block"
                  >
                    {single?.Agent?.text}
                  </Tooltip>
                </div>
                <div className="d-flex align-items-baseline">
                  <Tooltip title={single?.Agent?.value?.toLocaleString()}>
                    <span className="wm-chart-card-value mr-1">
                      {simpleKFormatterOnly(single?.Agent?.value)}
                    </span>
                  </Tooltip>

                  {single?.Agent?.percent_change ? (
                    <span
                      className={`text_regular ${
                        single?.Agent?.percent_change === 0
                          ? "d-flex"
                          : "d-flex"
                      } align-items-baseline ${
                        String(single?.Agent?.text).toLowerCase() ===
                        String("Negative").toLowerCase()
                          ? single?.Agent?.percent_change > 0
                            ? "negative"
                            : single?.Agent?.percent_change < 0
                            ? "positive"
                            : "text-gray"
                          : single?.Agent?.percent_change > 0
                          ? "positive"
                          : single?.Agent?.percent_change < 0
                          ? "negative"
                          : "text-gray"
                      } font-size12 font-weight600`}
                    >
                      {single?.Agent?.percent_change > 0 ? (
                        <>
                          <CaretUpFilled className="font-size18" />
                          {" " +
                            Number(
                              single?.Agent?.percent_change
                            )?.toLocaleString() +
                            "%"}
                        </>
                      ) : single?.Agent?.percent_change < 0 ? (
                        <>
                          <CaretDownFilled className="font-size18" />
                          {" " +
                            Number(
                              single?.Agent?.percent_change
                            )?.toLocaleString() +
                            "%"}
                        </>
                      ) : (
                        "NA"
                      )}{" "}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div
                className={`${preview ? " " : "wm-chart-cards-item"} `}
                style={{ width: "100%" }}
              >
                <div className="text_regular font-weight500 mb-1 line-height-normal">
                  {single?.CSD?.text}{" "}
                  <Tooltip
                    placement="bottom"
                    title="Brand pending tickets will be available only when brand workflow is enabled for your group and all the brands have the same configuration."
                  >
                    <i className="fa fa-question-circle" />
                  </Tooltip>
                </div>
                <div className="d-flex align-items-baseline">
                  <Tooltip title={single?.CSD?.value?.toLocaleString()}>
                    <span className="wm-chart-card-value mr-1">
                      {simpleKFormatterOnly(single?.CSD?.value)}
                    </span>
                  </Tooltip>

                  {single?.CSD?.percent_change ? (
                    <span
                      className={`text_regular ${
                        single?.CSD?.percent_change === 0 ? "d-flex" : "d-flex"
                      } align-items-baseline ${
                        String(single?.CSD?.text).toLowerCase() ===
                        String("Negative").toLowerCase()
                          ? single?.CSD?.percent_change > 0
                            ? "negative"
                            : single?.CSD?.percent_change < 0
                            ? "positive"
                            : "text-gray"
                          : single?.CSD?.percent_change > 0
                          ? "positive"
                          : single?.CSD?.percent_change < 0
                          ? "negative"
                          : "text-gray"
                      } font-size12 font-weight600`}
                    >
                      {single?.CSD?.percent_change > 0 ? (
                        <>
                          <CaretUpFilled className="font-size18" />
                          {" " +
                            Number(
                              single?.CSD?.percent_change
                            )?.toLocaleString() +
                            "%"}
                        </>
                      ) : single?.CSD?.percent_change < 0 ? (
                        <>
                          <CaretDownFilled className="font-size18" />
                          {" " +
                            Number(
                              single?.CSD?.percent_change
                            )?.toLocaleString() +
                            "%"}
                        </>
                      ) : (
                        "NA"
                      )}{" "}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-12 p-0 ">
          <div className="box-shadow mr-15 p-0 w-100 bg__gray border ">
            <div className="row m-0">
              <div
                className="col-12 col-md-3 p-15 border-right border-color"
                style={preview ? { minWidth: "35%" } : {}}
              >
                <div
                  className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 bg__white TATSummary__list--parent`}
                  style={{
                    boxShadow: "0 0 0.6rem #c3cbd780",
                    borderRadius: "0.4rem",
                    height: "8.5rem",
                  }}
                >
                  <div className="text_regular font-weight500 mb-1 line-height-normal">
                    <Tooltip
                      title={single?.TotalClosedTickets?.text}
                      placement="topLeft"
                      className="text-ellipsis d-block"
                    >
                      {single?.TotalClosedTickets?.text}
                    </Tooltip>
                  </div>
                  <div className="d-flex align-items-baseline">
                    <Tooltip
                      placement="bottom"
                      title={single?.TotalClosedTickets?.value?.toLocaleString()}
                    >
                      <span className="wm-chart-card-value mr-1">
                        {simpleKFormatterOnly(
                          single?.TotalClosedTickets?.value
                        )}
                      </span>
                    </Tooltip>
                    {single?.TotalClosedTickets?.percent_change ? (
                      <span
                        className={`text_regular ${
                          single?.TotalClosedTickets?.percent_change === 0
                            ? "d-flex"
                            : "d-flex"
                        } align-items-baseline ${
                          String(
                            single?.TotalClosedTickets?.text
                          ).toLowerCase() === String("Negative").toLowerCase()
                            ? single?.TotalClosedTickets?.percent_change > 0
                              ? "negative"
                              : single?.TotalClosedTickets?.percent_change < 0
                              ? "positive"
                              : "text-gray"
                            : single?.TotalClosedTickets?.percent_change > 0
                            ? "positive"
                            : single?.TotalClosedTickets?.percent_change < 0
                            ? "negative"
                            : "text-gray"
                        } font-size12 font-weight600`}
                      >
                        {single?.TotalClosedTickets?.percent_change > 0 ? (
                          <>
                            <CaretUpFilled className="font-size18" />
                            {" " +
                              Number(
                                single?.TotalClosedTickets?.percent_change
                              )?.toLocaleString() +
                              "%"}
                          </>
                        ) : single?.TotalClosedTickets?.percent_change < 0 ? (
                          <>
                            <CaretDownFilled className="font-size18" />
                            {" " +
                              Number(
                                single?.TotalClosedTickets?.percent_change
                              )?.toLocaleString() +
                              "%"}
                          </>
                        ) : (
                          "NA"
                        )}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <ul className="mt-15 TATSummary__list">
                  <li className="mb-15 TATSummary__list--item">
                    <div
                      className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 bg__white`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        height: "8.5rem",
                      }}
                    >
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        <Tooltip
                          title={single?.DirectlyClosed?.text}
                          placement="topLeft"
                          className="text-ellipsis d-block"
                        >
                          {single?.DirectlyClosed?.text}
                        </Tooltip>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <Tooltip
                          title={single?.DirectlyClosed?.value?.toLocaleString()}
                        >
                          <span className="wm-chart-card-value mr-1">
                            {simpleKFormatterOnly(
                              single?.DirectlyClosed?.value
                            )}
                          </span>
                        </Tooltip>

                        {single?.DirectlyClosed?.percent_change ? (
                          <span
                            className={`text_regular ${
                              single?.DirectlyClosed?.percent_change === 0
                                ? "d-flex"
                                : "d-flex"
                            } align-items-baseline ${
                              String(
                                single?.DirectlyClosed?.text
                              ).toLowerCase() ===
                              String("Negative").toLowerCase()
                                ? single?.DirectlyClosed?.percent_change > 0
                                  ? "negative"
                                  : single?.DirectlyClosed?.percent_change < 0
                                  ? "positive"
                                  : "text-gray"
                                : single?.DirectlyClosed?.percent_change > 0
                                ? "positive"
                                : single?.DirectlyClosed?.percent_change < 0
                                ? "negative"
                                : "text-gray"
                            } font-size12 font-weight600`}
                          >
                            {single?.DirectlyClosed?.percent_change > 0 ? (
                              <>
                                <CaretUpFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.DirectlyClosed?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : single?.DirectlyClosed?.percent_change < 0 ? (
                              <>
                                <CaretDownFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.DirectlyClosed?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : (
                              "NA"
                            )}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </li>
                  <li className="mb-15 TATSummary__list--item">
                    <div
                      className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 bg__white`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        height: "8.5rem",
                      }}
                    >
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        <Tooltip
                          title={single?.RespondedAndClosed?.text}
                          placement="topLeft"
                          className="text-ellipsis d-block"
                        >
                          {single?.RespondedAndClosed?.text}
                        </Tooltip>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <Tooltip
                          title={single?.RespondedAndClosed?.value?.toLocaleString()}
                        >
                          <span className="wm-chart-card-value mr-1">
                            {simpleKFormatterOnly(
                              single?.RespondedAndClosed?.value
                            )}
                          </span>
                        </Tooltip>

                        {single?.RespondedAndClosed?.percent_change ? (
                          <span
                            className={`text_regular ${
                              single?.RespondedAndClosed?.percent_change === 0
                                ? "d-flex"
                                : "d-flex"
                            } align-items-baseline ${
                              String(
                                single?.RespondedAndClosed?.text
                              ).toLowerCase() ===
                              String("Negative").toLowerCase()
                                ? single?.RespondedAndClosed?.percent_change > 0
                                  ? "negative"
                                  : single?.RespondedAndClosed?.percent_change <
                                    0
                                  ? "positive"
                                  : "text-gray"
                                : single?.RespondedAndClosed?.percent_change > 0
                                ? "positive"
                                : single?.RespondedAndClosed?.percent_change < 0
                                ? "negative"
                                : "text-gray"
                            } font-size12 font-weight600`}
                          >
                            {single?.RespondedAndClosed?.percent_change > 0 ? (
                              <>
                                <CaretUpFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.RespondedAndClosed?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : single?.RespondedAndClosed?.percent_change <
                              0 ? (
                              <>
                                <CaretDownFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.RespondedAndClosed?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : (
                              "NA"
                            )}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </li>
                  <li className="TATSummary__list--item">
                    <div
                      className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 bg__white`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        height: "8.5rem",
                      }}
                    >
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        <Tooltip
                          title={single?.EscalatedAndClosed?.text}
                          placement="topLeft"
                          className="text-ellipsis d-block"
                        >
                          {single?.EscalatedAndClosed?.text}
                        </Tooltip>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <Tooltip
                          title={single?.EscalatedAndClosed?.value?.toLocaleString()}
                        >
                          <span className="wm-chart-card-value mr-1">
                            {simpleKFormatterOnly(
                              single?.EscalatedAndClosed?.value
                            )}
                          </span>
                        </Tooltip>

                        {single?.EscalatedAndClosed?.percent_change ? (
                          <span
                            className={`text_regular ${
                              single?.EscalatedAndClosed?.percent_change === 0
                                ? "d-flex"
                                : "d-flex"
                            } align-items-baseline ${
                              String(
                                single?.EscalatedAndClosed?.text
                              ).toLowerCase() ===
                              String("Negative").toLowerCase()
                                ? single?.EscalatedAndClosed?.percent_change > 0
                                  ? "negative"
                                  : single?.EscalatedAndClosed?.percent_change <
                                    0
                                  ? "positive"
                                  : "text-gray"
                                : single?.EscalatedAndClosed?.percent_change > 0
                                ? "positive"
                                : single?.EscalatedAndClosed?.percent_change < 0
                                ? "negative"
                                : "text-gray"
                            } font-size12 font-weight600`}
                          >
                            {single?.EscalatedAndClosed?.percent_change > 0 ? (
                              <>
                                <CaretUpFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.EscalatedAndClosed?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : single?.EscalatedAndClosed?.percent_change <
                              0 ? (
                              <>
                                <CaretDownFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.EscalatedAndClosed?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : (
                              "NA"
                            )}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                className="col-12 col-md-9 p-15"
                style={preview ? { maxWidth: "65%" } : {}}
              >
                <div
                  className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 bg__white TATSummary__list--parent d-flex align-items-center justify-content-between`}
                  style={{
                    boxShadow: "0 0 0.6rem #c3cbd780",
                    borderRadius: "0.4rem",
                    height: "8.5rem",
                  }}
                >
                  <div className="text_regular font-weight500 mb-1 line-height-normal">
                    <Tooltip
                      title={single?.AvgTATForClosedTickets?.text}
                      placement="topLeft"
                      className="text-ellipsis d-block"
                    >
                      <div>{single?.AvgTATForClosedTickets?.text}</div>
                    </Tooltip>
                    <div className="text-gray font-size12 font-weight400 mt-2">
                      Include Directly Closed,Escalated And Closed, Replied And
                      Closed
                    </div>
                  </div>
                  <div className="d-flex align-items-baseline">
                    {/* Currenlty commented, we are not used tat for this, do later */}
                    {/* <span
                      className={`wm-chart-card-value mr-1 ${
                        single?.AvgTATForClosedTickets?.value > tat
                          ? "error"
                          : ""
                      }`}
                    >
                      {secondsToDhms(single?.AvgTATForClosedTickets?.value)
                        ? secondsToDhms(single?.AvgTATForClosedTickets?.value)
                        : 0}
                    </span> */}
                    <span className={`wm-chart-card-value mr-1`}>
                      {single?.AvgTATForClosedTickets?.value}
                    </span>

                    {single?.AvgTATForClosedTickets?.percent_change ? (
                      <span
                        className={`text_regular ${
                          single?.AvgTATForClosedTickets?.percent_change === 0
                            ? "d-flex"
                            : "d-flex"
                        } align-items-baseline ${
                          String(
                            single?.AvgTATForClosedTickets?.text
                          ).toLowerCase() === String("Negative").toLowerCase()
                            ? single?.AvgTATForClosedTickets?.percent_change > 0
                              ? "negative"
                              : single?.AvgTATForClosedTickets?.percent_change <
                                0
                              ? "positive"
                              : "text-gray"
                            : single?.AvgTATForClosedTickets?.percent_change > 0
                            ? "positive"
                            : single?.AvgTATForClosedTickets?.percent_change < 0
                            ? "negative"
                            : "text-gray"
                        } font-size12 font-weight600`}
                      >
                        {single?.AvgTATForClosedTickets?.percent_change > 0 ? (
                          <>
                            <CaretUpFilled className="font-size18" />
                            {" " +
                              Number(
                                single?.AvgTATForClosedTickets?.percent_change
                              )?.toLocaleString() +
                              "%"}
                          </>
                        ) : single?.AvgTATForClosedTickets?.percent_change <
                          0 ? (
                          <>
                            <CaretDownFilled className="font-size18" />
                            {" " +
                              Number(
                                single?.AvgTATForClosedTickets?.percent_change
                              )?.toLocaleString() +
                              "%"}
                          </>
                        ) : (
                          "NA"
                        )}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <ul className="mt-15 TATSummary__list">
                  <li className="mb-15 TATSummary__list--item">
                    <div
                      className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 bg__white d-flex align-items-center justify-content-between`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        height: "8.5rem",
                      }}
                    >
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        <Tooltip
                          title={single?.AvgTATForDirectlyClosedTickets?.text}
                          placement="topLeft"
                          className="text-ellipsis d-block"
                        >
                          {single?.AvgTATForDirectlyClosedTickets?.text}
                        </Tooltip>
                      </div>
                      <div className="d-flex align-items-baseline">
                        {/* Currenlty commented, we are not used tat for this, do later */}
                        {/* <span
                          className={`wm-chart-card-value mr-1 ${
                            single?.AvgTATForDirectlyClosedTickets?.value > tat
                              ? "error"
                              : ""
                          }`}
                        >
                          {secondsToDhms(
                            single?.AvgTATForDirectlyClosedTickets?.value
                          )
                            ? secondsToDhms(
                                single?.AvgTATForDirectlyClosedTickets?.value
                              )
                            : 0}
                        </span> */}
                        <span className={`wm-chart-card-value mr-1`}>
                          {single?.AvgTATForDirectlyClosedTickets?.value}
                        </span>
                        {single?.AvgTATForDirectlyClosedTickets
                          ?.percent_change ? (
                          <span
                            className={`text_regular ${
                              single?.AvgTATForDirectlyClosedTickets
                                ?.percent_change === 0
                                ? "d-flex"
                                : "d-flex"
                            } align-items-baseline ${
                              String(
                                single?.AvgTATForDirectlyClosedTickets?.text
                              ).toLowerCase() ===
                              String("Negative").toLowerCase()
                                ? single?.AvgTATForDirectlyClosedTickets
                                    ?.percent_change > 0
                                  ? "negative"
                                  : single?.AvgTATForDirectlyClosedTickets
                                      ?.percent_change < 0
                                  ? "positive"
                                  : "text-gray"
                                : single?.AvgTATForDirectlyClosedTickets
                                    ?.percent_change > 0
                                ? "positive"
                                : single?.AvgTATForDirectlyClosedTickets
                                    ?.percent_change < 0
                                ? "negative"
                                : "text-gray"
                            } font-size12 font-weight600`}
                          >
                            {single?.AvgTATForDirectlyClosedTickets
                              ?.percent_change > 0 ? (
                              <>
                                <CaretUpFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.AvgTATForDirectlyClosedTickets
                                      ?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : single?.AvgTATForDirectlyClosedTickets
                                ?.percent_change < 0 ? (
                              <>
                                <CaretDownFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.AvgTATForDirectlyClosedTickets
                                      ?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : (
                              "NA"
                            )}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </li>
                  <li className="mb-15 TATSummary__list--item">
                    <div
                      className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 bg__white d-flex align-items-center justify-content-between`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        height: "8.5rem",
                      }}
                    >
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        <Tooltip
                          title={single?.AvgTATForRespondedClosedTickets?.text}
                          placement="topLeft"
                          className="text-ellipsis d-block"
                        >
                          {single?.AvgTATForRespondedClosedTickets?.text}
                        </Tooltip>
                      </div>
                      <div className="d-flex align-items-baseline">
                        {/* Currenlty commented, we are not used tat for this, do later */}
                        {/* <span
                          className={`wm-chart-card-value mr-1 ${
                            single?.AvgTATForRespondedClosedTickets?.value > tat
                              ? "error"
                              : ""
                          }`}
                        >
                          {secondsToDhms(
                            single?.AvgTATForRespondedClosedTickets?.value
                          )
                            ? secondsToDhms(
                                single?.AvgTATForRespondedClosedTickets?.value
                              )
                            : 0}
                        </span> */}
                        <span className={`wm-chart-card-value mr-1 `}>
                          {single?.AvgTATForRespondedClosedTickets?.value}
                        </span>
                        {single?.AvgTATForRespondedClosedTickets
                          ?.percent_change ? (
                          <span
                            className={`text_regular ${
                              single?.AvgTATForRespondedClosedTickets
                                ?.percent_change === 0
                                ? "d-flex"
                                : "d-flex"
                            } align-items-baseline ${
                              String(
                                single?.AvgTATForRespondedClosedTickets?.text
                              ).toLowerCase() ===
                              String("Negative").toLowerCase()
                                ? single?.AvgTATForRespondedClosedTickets
                                    ?.percent_change > 0
                                  ? "negative"
                                  : single?.AvgTATForRespondedClosedTickets
                                      ?.percent_change < 0
                                  ? "positive"
                                  : "text-gray"
                                : single?.AvgTATForRespondedClosedTickets
                                    ?.percent_change > 0
                                ? "positive"
                                : single?.AvgTATForRespondedClosedTickets
                                    ?.percent_change < 0
                                ? "negative"
                                : "text-gray"
                            } font-size12 font-weight600`}
                          >
                            {single?.AvgTATForRespondedClosedTickets
                              ?.percent_change > 0 ? (
                              <>
                                <CaretUpFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.AvgTATForRespondedClosedTickets
                                      ?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : single?.AvgTATForRespondedClosedTickets
                                ?.percent_change < 0 ? (
                              <>
                                <CaretDownFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.AvgTATForRespondedClosedTickets
                                      ?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : (
                              "NA"
                            )}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </li>
                  <li className="TATSummary__list--item">
                    <div
                      className={`wm-chart-cards-item box-shadow mr-15 p-15 w-100 bg__white d-flex align-items-center justify-content-between`}
                      style={{
                        boxShadow: "0 0 0.6rem #c3cbd780",
                        borderRadius: "0.4rem",
                        height: "8.5rem",
                      }}
                    >
                      <div className="text_regular font-weight500 mb-1 line-height-normal">
                        <Tooltip
                          title={single?.AvgTATForEscalatedClosedTickets?.text}
                          placement="topLeft"
                          className="text-ellipsis d-block"
                        >
                          {single?.AvgTATForEscalatedClosedTickets?.text}
                        </Tooltip>
                      </div>
                      <div className="d-flex align-items-baseline">
                        {/* Currenlty commented, we are not used tat for this, do later */}
                        {/* <span
                          className={`wm-chart-card-value mr-1 ${
                            single?.AvgTATForEscalatedClosedTickets?.value > tat
                              ? "error"
                              : ""
                          }`}
                        >
                          {secondsToDhms(
                            single?.AvgTATForEscalatedClosedTickets?.value
                          )
                            ? secondsToDhms(
                                single?.AvgTATForEscalatedClosedTickets?.value
                              )
                            : 0}
                        </span> */}
                        <span className={`wm-chart-card-value mr-1`}>
                          {single?.AvgTATForEscalatedClosedTickets?.value}
                        </span>
                        {single?.AvgTATForEscalatedClosedTickets
                          ?.percent_change ? (
                          <span
                            className={`text_regular ${
                              single?.AvgTATForEscalatedClosedTickets
                                ?.percent_change === 0
                                ? "d-flex"
                                : "d-flex"
                            } align-items-baseline ${
                              String(
                                single?.AvgTATForEscalatedClosedTickets?.text
                              ).toLowerCase() ===
                              String("Negative").toLowerCase()
                                ? single?.AvgTATForEscalatedClosedTickets
                                    ?.percent_change > 0
                                  ? "negative"
                                  : single?.AvgTATForEscalatedClosedTickets
                                      ?.percent_change < 0
                                  ? "positive"
                                  : "text-gray"
                                : single?.AvgTATForEscalatedClosedTickets
                                    ?.percent_change > 0
                                ? "positive"
                                : single?.AvgTATForEscalatedClosedTickets
                                    ?.percent_change < 0
                                ? "negative"
                                : "text-gray"
                            } font-size12 font-weight600`}
                          >
                            {single?.AvgTATForEscalatedClosedTickets
                              ?.percent_change > 0 ? (
                              <>
                                <CaretUpFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.AvgTATForEscalatedClosedTickets
                                      ?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : single?.AvgTATForEscalatedClosedTickets
                                ?.percent_change < 0 ? (
                              <>
                                <CaretDownFilled className="font-size18" />
                                {" " +
                                  Number(
                                    single?.AvgTATForEscalatedClosedTickets
                                      ?.percent_change
                                  )?.toLocaleString() +
                                  "%"}
                              </>
                            ) : (
                              "NA"
                            )}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TatSummary;
